import useCaseList from "../../features/cases/useCaseList";
import CaseListDesktop from "../cases/CaseListDesktop";
import { ADJUSTICE_CONFIG } from "./adjusticeConfig";

const LIST = { endpoint: "/adjustice" };

const AdjusticeDesktop = () => (
  <CaseListDesktop config={ADJUSTICE_CONFIG} list={useCaseList(LIST)} />
);

export default AdjusticeDesktop;
